export default function (children: React.ReactNode[]): React.ReactNode[] {
  const childList: React.ReactNode[] = []

  children.forEach((child: React.ReactNode) => {
    const prevChild = childList[childList.length - 1]
    if (typeof child === 'string' && typeof prevChild === 'string') {
      childList[childList.length - 1] += child
    } else {
      childList.push(child)
    }
  })

  return childList
}
